import(/* webpackMode: "eager" */ "/vercel/path0/app/auth/forgot-password/page.tsx");
